export default {
  settings: [],
  infoDB: {}
}
